// extracted by mini-css-extract-plugin
export var textInput = "_h3-0";